// extracted by mini-css-extract-plugin
export default {"up_button":"upButton_up_button__DydQR","movebtn":"upButton_movebtn__1FNLS","is_visible":"upButton_is_visible__Asflm"};